<script lang="ts" setup>
import { readonly, toRef } from 'vue';

import { provideSkeletonRowContext } from './model';

const props = defineProps<{
  index: number;
}>();
provideSkeletonRowContext({
  index: readonly(toRef(props, 'index')),
});
</script>
<template>
  <slot />
</template>
